<template>
  <div class="reservation-component">
    <div class="row">
      <div class="col-md-5">
        <div class="box box-primary">
          <div class="box-header">
            <h1 class="box-title">Search</h1>
          </div>
          <form role="form" class="form-horizontal">
            <div class="box-body">
              <template v-if="isMasterAccount">
                <div v-if="searchCriteria.drivers.objects.length > 0">
                  <object-select-input
                    :field.sync="searchCriteria.drivers">
                  </object-select-input>
                  <div class="alert alert-info" v-if="accountUuid != searchCriteria.drivers.value && searchCriteria.drivers.value">
                    By selecting a driver other than yourself, this booking
                    becomes a business booking and only business credit cards
                    may be used.
                  </div>
                </div>
              </template>
              <div class="form-group" v-show="!chooseLocation">
                <label class="col-sm-4 control-label">Location</label>
                <div class="col-sm-8">
                  <span v-if="location">Using Current Location</span>
                  <span v-else>Cannot Get Current Location</span>
                  <br/>
                  <a @click="chooseLocation = true" class="btn btn-info btn-sm">Choose from saved locations</a>
                </div>
              </div>
              <div v-if="chooseLocation">
                <object-select-input
                  :field.sync="searchCriteria.locations">
                </object-select-input>
                <div class="form-group">
                  <template v-if="searchCriteria.locations.objects.length > 0">
                    <div class="col-sm-8 col-sm-offset-4">
                      <a class="btn btn-default btn-sm" @click="addLocationModal">Add a new location</a>
                      <a @click="useCurrent()" class="btn btn-info btn-sm">Use current location</a>
                    </div>
                  </template>
                  <template v-else>
                    <label class="col-sm-4 control-label">Location</label>
                    <div class="col-sm-8">
                      You have not added any locations.<br/>
                      <a class="interactive-cursor" @click="addLocation">Click here to add one.</a>
                      <a @click="useCurrent()" class="btn btn-info btn-sm">Use current location</a>
                    </div>
                  </template>
                </div>
              </div>
              <div class="form-section-info">
                Enter an address below to find cars closest to that location.
              </div>
              <address-input v-bind:field="searchLocationAddress"></address-input>
              <date-time-range-input v-ref:date-time :field.sync="searchCriteria"></date-time-range-input>
              <text-input :field.sync="searchCriteria.carNumber"></text-input>
              <objects-select-input :field.sync="searchCriteria.types"></objects-select-input>
              <template v-for="field in searchCriteria.features">
                <checkbox-input :field.sync="field"></checkbox-input>
              </template>
            </div>
            <div class="box-footer">
              <button type="submit" class="btn btn-default"
                v-on:click.prevent="search()">Refresh Results</button>
            </div>
          </form>
        </div>
      </div>
      <div class="col-md-7">
        <div class="box">
          <div class="box-header">
            <h1 class="box-title">Cars</h1>
          </div>
          <div class="box-body">
            <template v-if="cars.length > 0 || mapCars.length > 0">
              <div class="nav-tabs-custom">
                <ul class="nav nav-tabs">
                  <li class="active">
                    <a href="#tab_1" data-toggle="tab" aria-expanded="true">
                      <span class="fa fa-fw fa-list"></span> List
                    </a>
                  </li>
                  <li class="">
                    <a href="#tab_2" data-toggle="tab" aria-expanded="false"
                    v-on:click="showMap()"><span class="fa fa-fw fa-map"></span>
                    Map
                  </a>
                  </li>
                </ul>
                <div class="tab-content">
                  <div class="tab-pane active" id="tab_1">
                    <template v-if="$root.oneWayTrips">
                      <br/>
                      <label class="label label-black label-margin">
                        <span class="fa fa-check fa-lg"></span> One Way
                      </label> Car available for one way trip
                    </template>
                    <center>
                      <br/>
                      <paging-input v-if="cars.length" :options="pagingOptions"></paging-input>
                    </center>
                    <template v-for="car in cars">
                      <car-item :car="car"
                      :start-time="searchCriteria.startDate"
                      :end-time="searchCriteria.endDate"
                      :location="showDistance">
                      </car-item>
                    </template>
                    <center>
                      <br/>
                      <paging-input v-if="cars.length" :options="pagingOptions"></paging-input>
                    </center>
                  </div>
                  <div class="tab-pane" id="tab_2">
                    <div id="reservation_map" style="height:450px;"></div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              No items match your search criteria.
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- Reserve Modal -->
    <modal v-if="reserveModalActive" v-el:reserve-modal>
      <template slot="header">
        Confirm Reservation
      </template>
      <template slot="body">
        <div class="alert alert-info">
          Please confirm that the below information is correct:
        </div>
        <div class="car-details clearfix">
          <center>
          <img :src="'https://techcar-dev.s3.amazonaws.com/' +
          selectedCar.CarType.AmazonImage.objectKey"/>
          <p><strong>
            {{ selectedCar.CarType.name }} (#{{ selectedCar.convadisId }}
            - {{ selectedCar.name }})
          </strong></p>
          <p>
            <span class="fa fa-map-marker fa-fw"></span>
            {{ selectedCar.Lot.address }}
          </p>
          </center>
        </div>
        <hr/>
        <template v-if="isMasterAccount">
          <div class="form-horizontal" v-if="searchCriteria.drivers.objects.length > 0">
            <object-select-input :field.sync="searchCriteria.drivers"></object-select-input>
            <div class="alert alert-info" v-if="accountUuid != searchCriteria.drivers.value && searchCriteria.drivers.value">
              By selecting a driver other than yourself, this booking becomes a business booking and only business credit cards may be used.
            </div>
            <div>
            </div>
          </div>
        </template>
        <div class="callout callout-success">
          <date-time-range-input v-ref:date-time-modal :field.sync="searchCriteria"></date-time-range-input>
        </div>
        <reservation-promo-input
          v-ref:promo
          :field="object.promo"
          :user="object.driverUuid"
          :date="searchCriteria"
          :car="object.carUuid">
	       </reservation-promo-input>
        <price-breakdown :object.sync="object"></price-breakdown>
        <h4>Memo:</h4>
        <textarea-input :field.sync="memo"></textarea-input>
        <div class="checkbox">
          <label>
            <input type="checkbox" v-model="agreement"/>
            <strong>Agreement</strong><span class="required">*</span><br/>
            I agree to the terms and conditions outlined in the
            <a :href="$root.muaUrl"
             target="_blank">Member User Agreement</a>
          </label>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" v-model="driversLicense"/>
            <strong>Driver's License</strong><span class="required">*</span>
            <br/>
            I have a valid driver's license on file
          </label>
        </div>
        <p class="callout callout-warning" v-if="!hasLicense">
          You do not currently have drivers licence on file. Please upload a
           drivers license. To do so,
           <a data-dismiss="modal" v-link="{path: '/my-account?tab=driver-info'}">
             <strong>click here</strong>
           </a>.
        </p>
        <div class="row">
          <div class="col-sm-12">
            <span class="form-validation-error" v-show="!$refs.dateTimeModal.valid">
              <span class="fa fa times"></span>
              You have selected an invalid time for this booking.
            </span>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button type="button" class="btn btn-info pull-left" data-dismiss="modal">Cancel</button>
        <button :disabled="!$refs.dateTimeModal.valid" class="btn btn-default" data-dismiss="modal" @click="oneWayTrips ? showOwt() : showExtras()">{{ optionalButtonText }}</button>
      </template>
    </modal>
    <!-- one way trip modal -->
    <modal v-if="owtModalActive" v-el:owt-modal>
      <template slot="header">
        One Way Trip Options
      </template>
      <template slot="body">
        <div class="row">
          <div class="col-sm-12">
            <strong>ORIGIN</strong><br/>
            <input class="form-control" type="text" :value="selectedCar.Lot.address" readonly />
          </div>
        </div><br/>
        <div class="row" v-if="!differentDestination">
          <div class="col-sm-12">
            <strong>RETURN CAR TO</strong><br/>
            <input class="form-control" type="text" :value="selectedCar.Lot.address" readonly /><br/>
            <button class="btn btn-default" @click="getAvailableLots()">Change Return Address</button>
          </div>
        </div>
        <div class="row" v-if="differentDestination">
          <div class="col-sm-12">
            <strong>RETURN CAR TO</strong><br/>
          </div>
          <object-select-input
            :field.sync="availableLots">
          </object-select-input>
          <address-input :field.sync="newLotAddress"></address-input>
        </div>
      </template>
      <template slot="footer">
        <button type="button" class="btn btn-info pull-left" @click="backToReserve()">Back</button>
        <button class="btn btn-default" data-dismiss="modal" @click="showExtras()">{{ optionalButtonText }}</button>
      </template>
    </modal>
    <!-- optional extras modal(s) -->
    <template v-if="object.optionalExtras">
      <modal v-if="optionalModalActive" v-el:optional-modal>
        <template slot="header">
          {{ object.optionalExtras[optionalExtraIndex].name }}
        </template>
        <template slot="body">
          <div class="checkbox">
            <label>
              <input type="checkbox" @change="updateExtras(object.optionalExtras[optionalExtraIndex])" :checked="checkedExtra"/>
              <strong>Yes, I would like {{ object.optionalExtras[optionalExtraIndex].name }}</strong><br/>
              {{ object.optionalExtras[optionalExtraIndex].description }}
            </label>
          </div>
          <price-table :price-breakdown.sync="object" ></price-table>
        </template>
        <template slot="footer">
          <button type="button" class="btn btn-info pull-left" @click="previousExtra()">Back</button>
          <button class="btn btn-default" @click="nextExtra()">{{ optionalButtonText }}</button>
        </template>
      </modal>
    </template>
    <!-- Error Modal -->
    <error-modal v-if="errorModalActive" :error-message="reservationError"></error-modal>
    <!-- New Location Modal -->
    <modal v-if="addLocationModalActive" v-el:add-location-modal>
      <template slot="header">
        Add Location
      </template>
      <template slot="body">
        <form class="form-horizontal">
        <text-input :field.sync="locationName"></text-input>
        <address-input :field.sync="locationAddress"></address-input>
          <div class="row" v-show="addressError" transition="expand">
            <div class="col-sm-8 col-sm-offset-4">
              <div class="form-section-danger">{{ addressError }}</div>
            </div>
          </div>
        </form>
      </template>
      <template slot="footer">
        <button type="button" class="btn btn-info pull-left" data-dismiss="modal">Cancel</button>
        <button class="btn btn-default" @click="addLocation">Add</button>
      </template>
    </modal>
  </div>
</template>

<script>
import AddressInput from '../inputs/AddressInput.vue'
import CarItem from '../displays/CarItem.vue'
import CheckboxInput from '../inputs/CheckboxInput.vue'
import DateTimeRangeInput from '../inputs/DateTimeRangeInput.vue'
import ErrorModal from '../modals/ErrorModal.vue'
import Modal from '../Modal'
import ObjectSelectInput from '../inputs/ObjectSelectInput.vue'
import ObjectsSelectInput from '../inputs/ObjectsSelectInput.vue'
import PagingInput from '../inputs/PagingInput'
import PriceBreakdown from '../displays/PriceBreakdown.vue'
import PriceTable from '../displays/PriceTable.vue'
import ReservationPromoInput from '../inputs/ReservationPromoInput'
import TextareaInput from '../inputs/TextareaInput.vue'
import TextInput from '../inputs/TextInput.vue'
import '../../vendor/jquery.serialize-object.js'
import '../../vendor/datetime.min.js'

export default {
  name: 'Reservation',
  components: {
    AddressInput,
    CarItem,
    CheckboxInput,
    DateTimeRangeInput,
    ErrorModal,
    Modal,
    ObjectSelectInput,
    ObjectsSelectInput,
    PagingInput,
    PriceBreakdown,
    PriceTable,
    ReservationPromoInput,
    TextareaInput,
    TextInput
  },
  data () {
    let now = moment()
    return {
      availableLots: {
        value: '',
        objects: [],
        objectName: 'label'
      },
      differentDestination: false,
      oneWayTrips: false,
      owtModalActive: false,
      hasLicense: true,
      addressError: false,
      searchLocationAddress: {
        name: 'search_address',
        type: 'address',
        label: 'Address',
        value: '',
        confirmation: true,
        valid: false,
        dirty: false,
        latitude: 0,
        longitude: 0,
        hiddenMap: true,
        required: true,
        uuid: ''
      },
      newLotAddress: {
        name: 'newLot_address',
        value: '',
        latitude: 0,
        longitude: 0,
        hiddenBar: true,
        required: true,
        uuid: '',
        noClick: true
      },
      locationAddress: {
        name: 'address',
        type: 'address',
        label: 'Address',
        value: '',
        confirmation: true,
        valid: false,
        dirty: false,
        latitude: 0,
        longitude: 0,
        required: true,
        uuid: ''
      },
      locationName: {
        name: 'name',
        label: 'Name',
        required: false,
        value: '',
        confirmation: true,
        valid: false,
        dirty: false
      },
      addLocationModalActive: false,
      optionalModalActive: false,
      optionalExtraIndex: 0,
      chooseLocation: false,
      object: {
        driverUuid: '',
        allowsFinanceCodes: false,
        businessReservation: false,
        carUuid: '',
        cost: {},
        cards: {
          required: true,
          valid: false,
          dirty: true
        },
        extras: [],
        rate: {},
        reservation: {},
        extraCredit: 0,
        optionalExtras: [],
        businessOnly: false,
        financeCode: {
          name: 'financeCode',
          label: 'Finance Code',
          objects: [],
          objectName: 'dropdownLabel',
          value: '',
          valid: false,
          dirty: false,
          required: true
        },
        promo: {
          label: 'Promotional Code',
          name: 'promo',
          value: '',
          dirty: false,
          valid: false,
          required: false
        }
      },
      reserveModalActive: false,
      errorModalActive: false,
      agreement: false,
      driversLicense: false,
      hasCard: false,
      reservationError: '',
      cars: [],
      mapCars: [],
      markers: [],
      selectedCar: {
        convadisId: '',
        name: '',
        Lot: {
          address: ''
        },
        CarType: {
          name: '',
          AmazonImage: {
            objectKey: 'spacer.gif'
          }
        }
      },
      searchCriteria: {
        startDate: now.clone().toDate(),
        endDate: now.clone().add(this.$root.minimumMinutes, 'minutes').toDate(),
        minimumMinutes: this.$root.minimumMinutes,
        maximumDays: this.$root.maximumDays,
        features: [],
        types: {},
        lat: 0,
        long: 0,
        locations: {
          value: '',
          objects: []
        },
        drivers: {
          value: '',
          objects: [],
          valid: false,
          dirty: true,
          required: true
        },
        carNumber: {
          name: 'convadisId',
          label: 'Car Number',
          required: false,
          value: '',
          confirmation: true,
          valid: false,
          dirty: false
        }
      },
      authType: this.$route.authType,
      map: false,
      oms: false,
      infowindow: false,
      location: false,
      lat: 0,
      long: 0,
      showDistance: false,
      searchOffset: 0,
      searchLimit: 5,
      pagingOptions: {
        totalResults: 10,
        limit: 5,
        current: 1
      },
      conflictingReservations: [],
      selectedCard: {},
      memo: {
        dirty: true,
        valid: true,
        name: 'memo',
        value: '',
        height: '100px'
      },
      isMasterAccount: false,
      accountUuid: ''
    }
  },
  route: {
    data () {
      this.checkMaster()
      this.getLocation()
      this.getCarFeatures()
      this.getCarTypes()
      this.getSavedLocations()
    }
  },
  computed: {
    checkedExtra () {
      return this.object.extras.some((val) => val.uuid === this.object.optionalExtras[this.optionalExtraIndex].uuid)
    },
    optionalButtonText () {
      return this.optionalExtraIndex < (this.object.optionalExtras.length - 1) ? 'Next' : 'Confirm Reservation'
    }
  },
  events: {
    promoCodeActivated (promoRate) {
      this.updateCost()
    },
    changePage (page) {
      this.searchOffset = (page - 1) * this.searchLimit
      this.getCars()
    },
    dateTimeChanged () {
      this.differentDestination = false
      if (this.reserveModalActive && this.$refs.dateTimeModal.valid) {
        this.$refs.promo.validateField()
        this.updateCost()
      } else {
        this.getCars()
      }
    }
  },
  methods: {
    useCurrent () {
      this.chooseLocation = false
      this.search()
    },
    getAvailableLots () {
      this.$http.post(`${this.$route.authType}/available-bays`, {
        carId: this.selectedCar.uuid,
        startDate: this.searchCriteria.startDate,
        endDate: this.searchCriteria.endDate,
        lat: this.selectedCar.Lot.latitude,
        long: this.selectedCar.Lot.longitude
      }).then((response, status, request) => {
        this.availableLots.value = this.selectedCar.Lot.uuid
        this.availableLots.objects = response.data
        this.differentDestination = true
        this.newLotAddress.value = this.selectedCar.Lot.address
        this.newLotAddress.latitude = this.selectedCar.Lot.latitude
        this.newLotAddress.longitude = this.selectedCar.Lot.longitude
      })
    },
    checkMaster () {
      this.$http.get(`${this.$route.authType}/user/check-master`, {}).then((response, status, request) => {
        this.isMasterAccount = response.data.isMasterAccount
        this.accountUuid = response.data.accountUuid
        this.object.allowsFinanceCodes = response.data.hasFinanceCodes
        this.hasLicense = response.data.hasLicense
        this.hasCard = response.data.hasCard
        if (!this.hasCard) {
          this.errorModal('There is no smartcard associated with your GreenShareCar account. Please call 1300 575 878 for assistance.')
        }
        if (this.isMasterAccount) {
          this.$http.get(`${this.$route.authType}/reserve/get-drivers`, {}).then((response, status, request) => {
            this.searchCriteria.drivers = response.data.form
          })
        }
      })
    },
    updateExtras (extra) {
      let exists = this.object.extras.some((val) => val.uuid === extra.uuid)
      if (!exists) {
        this.object.extras.push(extra)
      } else {
        this.object.extras = this.object.extras.filter((val) => val.uuid !== extra.uuid)
      }
      this.updateCost()
    },
    showOwt () {
      if (!this.agreement) {
        this.errorModal('You did not agree to the Member User Agreement / Driver Obligations')
      } else if (!this.driversLicense) {
        this.errorModal('You did not declare that you have a valid driver\'s license')
      } else if (!this.selectedCard.uuid && !this.object.financeCode.valid && this.object.reservation.quotedCost > 0) {
        this.errorModal('You have not entered a valid payment method')
      } else {
        this.owtModalActive = true
        this.$nextTick(function () {
          $(this.$els.owtModal).modal()
          $(this.$els.owtModal).on('hidden.bs.modal', () => {
            this.owtModalActive = false
          })
        })
      }
    },
    showExtras () {
      if (this.optionalExtraIndex < this.object.optionalExtras.length - 1) {
        if (!this.agreement) {
          this.errorModal('You did not agree to the Member User Agreement / Driver Obligations')
        } else if (!this.driversLicense) {
          this.errorModal('You did not declare that you have a valid driver\'s license')
        } else if (!this.selectedCard.uuid && !this.object.financeCode.valid && this.object.reservation.quotedCost > 0) {
          this.errorModal('You have not entered a valid payment method')
        } else {
          this.optionalModalActive = true
          this.optionalExtraIndex = 0
          this.$nextTick(function () {
            $(this.$els.optionalModal).modal()
            $(this.$els.optionalModal).on('hidden.bs.modal', () => {
              this.optionalModalActive = false
            })
          })
        }
      } else {
        this.reserve()
      }
    },
    nextExtra () {
      if (this.optionalExtraIndex < this.object.optionalExtras.length - 1) {
        this.optionalExtraIndex++
      } else {
        this.reserve()
      }
    },
    backToReserve () {
      $(this.$els.owtModal).modal('hide')
      this.reserveModal(this.selectedCar)
    },
    previousExtra () {
      if (this.optionalExtraIndex !== 0) {
        this.optionalExtraIndex--
      } else {
        $(this.$els.optionalModal).modal('hide')
        if (this.oneWayTrips) {
          this.showOwt()
        } else {
          this.reserveModal(this.selectedCar)
        }
      }
    },
    reserve () {
      if (!this.agreement) {
        this.errorModal('You did not agree to the Member User Agreement / Driver Obligations')
      } else if (!this.driversLicense) {
        this.errorModal('You did not declare that you have a valid driver\'s license')
      } else if (!this.selectedCard.uuid && !this.object.financeCode.valid && this.object.cost.subTotalCost > 0) {
        this.errorModal('You have not selected a valid payment method')
      } else if (!this.hasCard) {
        this.errorModal('There is no smartcard associated with your GreenShareCar account. Please call 1300 575 878 for assistance.')
      } else {
        let authType = this.$route.authType
        let extras = this.object.extras
        let extraCredit = this.object.extraCredit
        let alreadyPaid = this.object.reservation.quotedCost || 0
        let reservation = this.searchCriteria
        let useCredits = true
        if (this.object.businessReservation || this.object.financeCode.value) useCredits = false
        reservation.memo = this.memo.value
        // Here is the call to an API.
        // For example, If user is directly calling our API then I should always write some restriction on mandatory fields inside server API.
        // Because other users doesn't know about our code and doesn't know that which fields are mandatory or not.
        // Here comes the importance of validation on server side instead of client side.
        // Because if user is using the api calls then he won't go through client validation.
        this.$http.post(`${authType}/reserve`, {
          destinationLot: this.availableLots.value || this.selectedCar.Lot.uuid,
          selectedCar: this.selectedCar,
          reservation,
          extras,
          extraCredit,
          alreadyPaid,
          selectedCard: this.selectedCard,
          useCredits,
          financeCode: this.object.financeCode.value,
          promo: this.object.promo.value
        }).then((response, status, request) => {
          this.$route.router.go(`/reserve/confirm/${response.data.resUuid}`)
        }).catch((err) => {
          this.errorModal(err.body)
        })
      }
    },
    checkConflictingReservations () {
      let authType = this.$route.authType
      this.conflictingReservations = []
      this.$http.get(`${authType}/reserve/check`, {
        params: {
          startDate: moment(this.searchCriteria.startDate).valueOf(),
          endDate: moment(this.searchCriteria.endDate).valueOf(),
          carId: this.selectedCar.convadisId
        }
      }).then((response, status, request) => {
        this.conflictingReservations = response.data
      })
    },
    getCarTypes () {
      this.$http.get(`${this.authType}/reserve/car-types`).then((response, status, request) => {
        this.searchCriteria.types = response.data.form
      })
    },
    getSavedLocations () {
      this.$http.get(`${this.authType}/reserve/saved-locations`).then((response, status, request) => {
        this.searchCriteria.locations = response.data.form
      })
    },
    getLocation () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.location = true
          this.lat = position.coords.latitude
          this.long = position.coords.longitude
          this.locationAddress.latitude = position.coords.latitude
          this.locationAddress.longitude = position.coords.longitude
          this.getCars()
        })
      }
      if (!this.location) {
        this.getCars()
        this.locationAddress.latitude = -37.81656469809118
        this.locationAddress.longitude = 144.9674615263939
      }
    },
    getCarFeatures () {
      this.$http.get(`${this.authType}/reserve/features`).then((response, status, request) => {
        this.searchCriteria.features = response.data.form
      })
    },
    reserveModal (car) {
      this.oneWayTrips = car.oneWayTrips && this.$root.oneWayTrips && car.Lot.oneWayTrips && car.Organization.oneWayTrips && !car.LotRelocations.length
      this.selectedCar = car
      let startDate = moment(this.searchCriteria.startDate).valueOf()
      let endDate = moment(this.searchCriteria.endDate).valueOf()
      let carUuid = this.selectedCar.uuid
      let authType = this.$route.authType
      let useCredits = true
      if (this.object.businessReservation || this.object.allowsFinanceCodes) useCredits = false
      this.$http.post(`${authType}/reserve/costs`, {
        accountUuid: this.object.driverUuid,
        carUuid,
        lotUuid: this.selectedCar.Lot.uuid,
        startDate,
        endDate,
        useCredits,
        extras: [],
        extraCredit: 0,
        alreadyPaid: 0,
        createdAt: null,
        businessOnly: this.object.businessOnly,
        promo: this.object.promo.value
      }).then((response, status, request) => {
        if (response.data.costs) {
          this.object.cost = response.data.costs.cost
          this.object.rate = response.data.costs.rate.rate
          this.object.optionalExtras = response.data.costs.rate.extras
          this.object.cards = response.data.cards
          this.object.carUuid = carUuid
          this.reserveModalActive = true
          this.$nextTick(function () {
            this.$broadcast('getReservationInfo')
            $(this.$els.reserveModal).modal()
            $(this.$els.reserveModal).on('hidden.bs.modal', () => {
              this.reserveModalActive = false
            })
          })
        } else {
          this.errorModal(response.body)
        }
      }).catch((err) => {
        this.errorModal(err.body || err.toString())
      })
    },
    updateCost () {
      let carUuid = this.selectedCar.uuid
      let startDate = this.searchCriteria.startDate
      let authType = this.$route.authType
      let extras = this.object.extras
      let endDate = this.searchCriteria.endDate
      let extraCredit = 0
      let alreadyPaid = 0
      let useCredits = true
      if (this.object.businessReservation || this.object.allowsFinanceCodes) useCredits = false
      this.$http.post(`${authType}/update-cost`, {
        accountUuid: this.object.driverUuid,
        carUuid,
        lotUuid: this.selectedCar.Lot.uuid,
        startDate,
        endDate,
        extras,
        extraCredit,
        alreadyPaid,
        useCredits,
        promo: this.object.promo.value
      }).then((response, status, request) => {
        this.object.allowsFinanceCodes = response.data.hasFinanceCodes
        if (response.data.hasFinanceCodes) {
          this.object.financeCode.objects = response.data.financeCodes
        }
        this.object.cost = response.data.cost
        this.object.rate = response.data.rate.rate
        this.object.optionalExtras = response.data.rate.extras
        this.object.extras = response.data.extras
      })
    },
    search () {
      this.searchOffset = 0
      this.getCars()
      if (this.map) this.showMap()
    },
    getCars () {
      this.showDistance = this.chooseLocation || this.location
      if (this.chooseLocation) {
        this.searchCriteria.locations.objects.forEach(location => {
          if (location.uuid === this.searchCriteria.locations.value) {
            this.searchCriteria.lat = location.latitude
            this.searchCriteria.long = location.longitude
          }
        })
      } else if (this.searchLocationAddress.latitude && this.searchLocationAddress.longitude) {
        this.searchCriteria.long = this.searchLocationAddress.longitude
        this.searchCriteria.lat = this.searchLocationAddress.latitude
      } else {
        this.searchCriteria.lat = this.lat
        this.searchCriteria.long = this.long
      }
      this.$http.post(`${this.authType}/reserve/search`, {
        searchCriteria: this.searchCriteria,
        offset: this.searchOffset,
        limit: this.searchLimit
      }).then((response, status, request) => {
        let page = (this.searchOffset / this.searchLimit) + 1
        if (response.data.cars.length === 0 && page === 1) {
          this.searchOffset = this.searchOffset + this.searchLimit
          this.errorModal(`Cars on page ${page} are all on restriction, defaulting to page ${page + 1}`)
          this.getCars()
        } else if (response.data.cars.length === 0) {
          this.errorModal('No cars matched your search')
        } else {
          this.cars = response.data.cars
          this.pagingOptions.current = (this.searchOffset / this.searchLimit) + 1
          this.pagingOptions.totalResults = response.data.count
          this.pagingOptions.limit = this.searchLimit
          this.$nextTick(function () {
            this.$broadcast('pagesUpdated', this.pagingOptions)
          })
        }
      })
    },
    showMap () {
      this.$http.post(`${this.authType}/reserve/search`, {
        searchCriteria: this.searchCriteria,
        organization: window.location.host,
        offset: 0
      }).then((response, status, request) => {
        this.mapCars = response.data.cars
        if (!this.map) {
          let centre = {
            lat: this.searchCriteria.lat,
            lng: this.searchCriteria.long
          }
          this.map =
            new google.maps.Map(document.getElementById('reservation_map'), {
              center: centre,
              zoom: 15
            })
          let image = '/public/images/you-are-here-marker.png'
          let latlng = new google.maps.LatLng(this.searchCriteria.lat, this.searchCriteria.long)
          this.markers.push(new google.maps.Marker({
            map: this.map,
            position: latlng,
            icon: image,
            optimized: false,
            zIndex: 0
          }))
          google.maps.event.addListenerOnce(this.map, 'idle', () => {
            google.maps.event.trigger(this.map, 'resize')
            this.map.panTo(centre)
          })
          this.oms = new OverlappingMarkerSpiderfier(this.map, {
            keepSpiderfied: true
          })
          this.mapCars.forEach((el, i, arr) => {
            this.addCar(el, i)
          })
          this.oms.addListener('click', (m, event) => {
            if (this.infowindow) this.infowindow.close()
            this.infowindow = new google.maps.InfoWindow({
              content: m.desc
            })
            this.infowindow.open(this.map, m)
            this.map.panTo(m.position)
            if (this.map.getZoom() < 11) {
              this.map.setZoom(11)
            }
            this.infowindow.addListener('domready', () => {
              $('.marker-reserve').unbind('click')
              $('.marker-reserve').click((e) => {
                let id = e.target.id.replace('marker_reserve_', '')
                this.reserveModal(this.mapCars[id])
              })
            })
          })
        } else {
          this.markers.forEach((m, i, arr) => {
            m.setMap(null)
            this.oms.removeMarker(m)
          })
          this.mapCars.forEach((el, i, arr) => {
            this.addCar(el, i)
          })
          let image = '/public/images/you-are-here-marker.png'
          let latlng = new google.maps.LatLng(this.searchCriteria.lat, this.searchCriteria.long)
          this.markers.push(new google.maps.Marker({
            map: this.map,
            position: latlng,
            icon: image,
            optimized: false,
            zIndex: 0
          }))
        }
      })
    },
    addCar (car, key) {
      let latlng = new google.maps.LatLng(car.Lot.latitude, car.Lot.longitude)
      let image = '/public/images/marker-unavailable.png'
      let info =
      `<div>
        <img class="pull-left" style="width: 100px;"
        src="https://techcar-dev.s3.amazonaws.com/${car.CarType.AmazonImage.objectKey}"/>
        <label class="control-label">${car.CarType.name}</label>
        <p>(#${car.convadisId} - ${car.name})</p>
        <p>${car.Lot.address}</p>`
      let zIndex = 0
      if (car.Reservations.length < 1) {
        image = '/public/images/marker-available.png'
        info += `
          <p><button class="btn btn-sm btn-default marker-reserve"
          id="marker_reserve_${key}">Reserve</button>
          <a href="/reserve/car/${car.uuid}?s=${this.searchCriteria.startDate.getTime()}&e=${this.searchCriteria.endDate.getTime()}" class="btn btn-default btn-sm">
          View Availability</a></p></div>`
        zIndex = 2
      } else {
        info += `
          <p class="text-muted">Unavailable<br/>
          <a href="/reserve/car/${car.uuid}?s=${this.searchCriteria.startDate.getTime()}&e=${this.searchCriteria.endDate.getTime()}" class="btn btn-default btn-sm">
          View Availability</a></p></div>`
        zIndex = 1
      }
      let marker = new google.maps.Marker({
        map: this.map,
        position: latlng,
        icon: image,
        optimized: false,
        zIndex
      })
      marker.desc = info
      this.oms.addMarker(marker)
      this.markers.push(marker)
    },
    errorModal (error) {
      this.reservationError = error
      this.errorModalActive = true
      this.$nextTick(function () {
        $('#errorModal').modal()
        $('#errorModal').on('hidden.bs.modal', () => {
          this.errorModalActive = false
        })
      })
    },
    addLocationModal () {
      this.addLocationModalActive = true
      this.$nextTick(function () {
        $(this.$els.addLocationModal).modal()
        this.$broadcast('modal-opened')
        $(this.$els.addLocationModal).on('hidden.bs.modal', () => {
          this.addLocationModalActive = false
        })
      })
    },
    addLocation () {
      if (this.locationAddress) {
        this.addressError = false
        this.$http.post(`${this.$route.authType}/form`, {
          address: this.locationAddress,
          name: this.locationName.value,
          permalink: 'addLocation'
        }).then((response, status, request) => {
          $(this.$els.addLocationModal).modal('toggle')
          this.getSavedLocations()
        })
      } else {
        this.addressError = 'Please enter an address'
      }
    }
  },
  watch: {
    'availableLots.value': function (newVal, oldVal) {
      let newLot = this.availableLots.objects.find(el => {
        return el.uuid === newVal
      })
      let newMarker = {
        address: newLot.address,
        lat: newLot.latitude,
        lng: newLot.longitude
      }
      this.$broadcast('updateMarker', newMarker)
    },
    'searchCriteria.locations.value': function (newVal, oldVal) {
      this.search()
    },
    'object.cards.value': function (newVal, oldVal) {
      this.object.cards.objects.forEach(card => {
        if (card.uuid === this.object.cards.value) {
          this.selectedCard = card
          if (card.cardType === 'Business') {
            this.object.businessReservation = true
          } else {
            this.object.businessReservation = false
          }
        }
      })
      this.updateCost()
    },
    'searchCriteria.drivers': function (newVal, oldVal) {
      this.object.driverUuid = this.searchCriteria.drivers.value
      this.$broadcast('getReservationInfo')
      let check = false
      if (this.object.businessOnly) {
        check = true
      }
      if (this.accountUuid !== this.searchCriteria.drivers.value) {
        this.object.businessOnly = true
      } else {
        this.object.businessOnly = false
      }
      if (this.object.businessOnly !== check && this.reserveModalActive) {
        this.object.cards.objects = []
        let startDate = moment(this.searchCriteria.startDate).valueOf()
        let endDate = moment(this.searchCriteria.endDate).valueOf()
        let carUuid = this.selectedCar.uuid
        let authType = this.$route.authType
        let useCredits = true
        if (this.object.businessReservation || this.object.allowsFinanceCodes) useCredits = false
        this.$http.post(`${authType}/reserve/costs`, {
          accountUuid: this.object.driverUuid,
          carUuid,
          startDate,
          endDate,
          useCredits,
          extras: [],
          extraCredit: 0,
          alreadyPaid: 0,
          createdAt: null,
          businessOnly: this.object.businessOnly,
          promo: this.object.promo.value
        }).then((response, status, request) => {
          this.object.allowsFinanceCodes = response.data.hasFinanceCodes
          this.object.financeCode.objects = response.data.financeCodes
          this.object.cards = response.data.cards
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Reservation.vue?d17b120e